module.exports = "vec2 bezier1(float t, vec2 p1, vec2 p2, vec2 c1) {\nreturn (1.0 - t) * (1.0 - t) * p1 + 2.0 * t * (1.0 - t) * c1 + t * t * p2;\n}"